import { useState } from "react";
import { api, formatApiError } from "@/lib/kfmApi";
import { getUtm } from "@/lib/utm";
import { Loader2, Check, Mail } from "lucide-react";
import { toast } from "sonner";

// Public email capture for OpenWord AI Daily Nuggets. No account required.
export default function NuggetSignup({ compact = false, testid = "nugget-signup" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const val = email.trim();
    if (!val || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
      toast.error("Please enter a valid email");
      return;
    }
    setLoading(true);
    try {
      await api.post("/nuggets/subscribe", { email: val, utm: getUtm() || undefined });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Couldn't sign you up — please try again");
    }
    setLoading(false);
  };

  if (done) {
    return (
      <div
        data-testid={`${testid}-success`}
        className="flex items-center gap-3 rounded-2xl bg-[#10222A] border border-[#00E5FF]/15 px-5 py-4 text-[#161D2F]"
      >
        <span className="w-8 h-8 shrink-0 rounded-full bg-[#00E5FF] text-[#07090E] flex items-center justify-center">
          <Check className="w-4 h-4" strokeWidth={2} />
        </span>
        <p className="text-sm leading-relaxed">
          You&rsquo;re in — a short verse and reflection will land in your inbox each day. Check your email to say hello.
        </p>
      </div>
    );
  }

  return (
    <form
      data-testid={testid}
      onSubmit={submit}
      noValidate
      className={`flex ${compact ? "flex-row" : "flex-col sm:flex-row"} gap-2.5 w-full`}
    >
      <div className="relative flex-1">
        <Mail className="w-4 h-4 text-slate-500 absolute left-3.5 top-1/2 -translate-y-1/2" strokeWidth={1.5} />
        <input
          data-testid={`${testid}-email`}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          className="w-full h-12 rounded-full border border-[#29344D] bg-[#0E131F] pl-10 pr-4 text-sm text-slate-300 placeholder:text-slate-500 focus:outline-none focus:border-[#00E5FF]/50 transition-colors"
        />
      </div>
      <button
        data-testid={`${testid}-submit`}
        type="submit"
        disabled={loading}
        className="h-12 shrink-0 rounded-full bg-[#00E5FF] hover:bg-[#00B8CC] text-[#07090E] text-sm font-medium px-6 flex items-center justify-center gap-2 transition-colors disabled:opacity-60"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} /> : "Get daily nuggets"}
      </button>
    </form>
  );
}
